const Resources = {

    table_headers: [
        { 
            text:   'Assignment #',
            value:  'number_assigment',
            type:   'link',
        },
        { 
            text:   'Description',
            align:  'start',
            value:  'description',
            type:   'link',
        },
        { 
            text: 'Days/Week',   
            value: 'days_per_week'
        },
        {   
            text: 'Avg. Time',
            value: 'avg_time_day'
        },
        {   
            text: 'Census',
            value: 'census',
            type: 'boolean'
        },
        { 
            text: 'Shift',
            value: 'shift'
        },
        { 
            text: 'Associate',
            value: 'associate'
        },
        { 
            text: 'Supervisor',
            value: 'supervisor'
        },
    ],

    room_complete_table_headers: [
        {
            name:       'Room',
            model:      '',
            checkbox:   false,
            id:         'room',
        },
        {
            name:       'Task',
            model:      '',
            checkbox:   false,
            id:         'task',
        },
        {
            name:       'Step codes',
            model:      '',
            checkbox:   false,
            id:         'step_codes',
        },
        {
            name:       '#',
            model:      '',
            checkbox:   false,
            id:         'hash',
        },
    ],

    lite_assignment_table_headers: [
        { 
            name:   'Assignment',
        },
        {   
            name:   'Frequency',
        },
    ],
    
    bed_table_headers: [
        { 
            text:   'Bed code',
            value:  'bed_code',
        },
        { 
            text:   'Room',
            value:  'room',
        },
        { 
            text:   'Minutes',
            value:  'minutes',
        },
        { 
            text:   'Associate',
            value:  'associate',
        },
        { 
            text:   'Added at',
            value:  'created_at',
        },
    ],

    employee_table_headers: [
        { 
            text:   'Assignment #',
            value:  'number_assigment',
            type:   'link',
        },
        { 
            text:   'Description',
            align:  'start',
            value:  'description',
            type:   'link',
        },
        { 
            text: 'Days/Week',   
            value: 'days_per_week'
        },
    ],

    note_table_headers: [
        { 
            name:   'Select',
        },
        {   
            name:   'Assignment #',
        },
        { 
            name:   'Description',
        },
    ],

    note_duty_table_headers: [
        {   
            text:   'Assignment #',
            value: 'number_assigment'
        },
        { 
            text:   'Description',
            value: 'description'
        },
    ],

    room_table_headers: [
        {
            name:       '#',
            model:      '',
            checkbox:   false,
            id:         'n',
        },
        {
            name:       'Room',
            model:      '',
            checkbox:   false,
            id:         'room',
        },
        {
            name:       'Task',
            model:      '',
            checkbox:   false,
            id:         'task',
        },
        {
            name:       'Sun',
            model:      'sunday',
            checkbox:   true,
            id:         'sun',
        },
        {
            name:       'Mon',
            model:      'monday',
            checkbox:   true,
            id:         'mon',
        },
        {
            name:       'Tue',
            model:      'tuesday',
            checkbox:   true,
            id:         'tue',
        },
        {
            name:       'Wed',
            model:      'wednesday',
            checkbox:   true,
            id:         'wed',
        },
        {
            name:       'Thu',
            model:      'thursday',
            checkbox:   true,
            id:         'thu',
        },
        {
            name:       'Fri',
            model:      'friday',
            checkbox:   true,
            id:         'fri',
        },
        {
            name:       'Sat',
            model:      'saturday',
            checkbox:   true,
            id:         'sat',
        },
        {
            name:       'Min',
            model:      '',
            checkbox:   false,
            id:         'min',
        },
        {
            name:       'SQ Ft',
            model:      '',
            checkbox:   false,
            id:         'sqft',
        },
       
    ],

    week_table_headers: [
        {
            name: 'Sun',
        },
        {
            name: 'Mon',
        },
        {
            name: 'Tue',
        },
        {
            name: 'Wed',
        },
        {
            name: 'Thu',
        },
        {
            name: 'Fri',
        },
        {
            name: 'Sat',
        },
    ],

    schedule_models: {
        'monday':     false,
        'tuesday':    false,
        'wednesday':  false,
        'thursday':   false,
        'friday':     false,
        'saturday':   false,
        'sunday':     false,
    },

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Daily Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "",
        },
    ],


    breadcrumb_modal_beds:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        }
        
    ],

    breadcrumb_employee:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
    
    ],

    boolean_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    excl_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    freq_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

    excel_file_headers: {
        'Assignment #': 'number_assigment',
        'Description': 'description',
        'Associate': 'associate_id',
        'Supervisor': 'supervisor_associate_id',
        'Shift': 'shift_id',
        'Group': 'group_id',
        'Department': 'cost_center_department_id',
        'Associate pager': 'associate_pager',
        'Supervisor pager': 'supervisor_pager',
        'Days per week': 'days_per_week',
        'Include in census': 'census',
        'Minutes/discharge': 'minutes',
        'Notes':'notes'
    },

    empty_format_data: [
        {
            number_assigment: '',
            description: '',
            associate_id: '',
            supervisor_associate_id: '',
            shift_id: '',
            group_id: '',
            cost_center_department_id: '',
            associate_pager: '',
            supervisor_pager: '',
            days_per_week: 0,
            census: false,
            minutes: 0
        },
    ],

    empty_assignment_rooms_format_data:
    [
        {
            'Assignment #': '',
            'Building Level Area': '',
            'Door #': '',
            'Task': '',
            'Order': '',
            'Sunday': 'TRUE',
            'Monday': 'TRUE',
            'Tuesday': 'TRUE',
            'Wednesday': 'TRUE',
            'Thursday': 'TRUE',
            'Friday': 'TRUE',
            'Saturday': 'TRUE',
        },
    ],

    
    excel_fields_required: {
        number_assigment: true,
        description: true,
        associate_id: false,
        supervisor_associate_id: false,
        shift_id: true,
        group_id: false,
        cost_center_department_id: false,
        associate_pager: false,
        supervisor_pager: false,
        days_per_week: true,
        census: false,
        minutes: false,
    },

    excel_file_headers_rooms: {
        'Assignment #': 'Assignment #',
        'Building Level Area': 'Building Level Area',
        'Door #': 'Door #',
        'Task': 'Task',
        'Order': 'Order',
        'Sunday': 'Sunday',
        'Monday': 'Monday',
        'Tuesday': 'Tuesday',
        'Wednesday': 'Wednesday',
        'Thursday': 'Thursday',
        'Friday': 'Friday',
        'Saturday': 'Saturday',
    },

    empty_format_data_rooms: [
        {
            'room_id': '',
            'task_id': '',
            'sunday': false,
            'monday': false,
            'tuesday': false,
            'wednesday': false,
            'thursday': false,
            'friday': false,
            'saturday': false,
        },
    ],

    excel_fields_required_rooms: {
        room_id: true,
        task_id: true,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
    },

    empty_format_data_notes: [
        {
            'Assignment #': '',
            'Minutes': 0,
            'Notes': '',
            'Include in Statuses': false,
            'Sunday': false,
            'Monday': false,
            'Tuesday': false,
            'Wednesday': false,
            'Thursday': false,
            'Friday': false,
            'Saturday': false,
        },
    ],

    excel_file_headers_notes: {
        'Assignment #': 'Assignment #',
        'Order': 'Order',
        'Minutes': 'Minutes',
        'Notes': 'Notes',
        'Include in Statuses': 'Include in Statuses',
        'Sunday': 'Sunday',
        'Monday': 'Monday',
        'Tuesday': 'Tuesday',
        'Wednesday': 'Wednesday',
        'Thursday': 'Thursday',
        'Friday': 'Friday',
        'Saturday': 'Saturday',
    },
    helps_main_screen: [
        {
            label: '¿How to add a Daily Assignment?', 
            instruction: `https://scribehow.com/embed/How_to_Add_a_Daily_Assignment__bYb2O77NQ6uxEqwUPhIdQg?as=scrollable`
        },
        {
            label: '¿How to delete Daily Assignments?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Daily_Assignments__PetRDiJFQry2Q0rgwrr0Kg?as=scrollable`
        },
        {
            label: 'Dashboard - Rooms Cleaned Update', 
            instruction: `https://scribehow.com/shared/Dashboard__Rooms_Cleaned_Update__UB2Wzyd0RWGNwtdjgYiF-A`
        },
        // {
        //     label: '¿How to add duties to a Daily Assignment?', 
        //     instruction: `https://scribehow.com/embed/How_to_Add_Duties_to_a_Daily_Assignment__y9ZyE-9QTYmmOWotqYHvag?as=scrollable`
        // },
        // {
        //     label: '¿How to move rooms for a day?', 
        //     instruction: `https://scribehow.com/embed/Daily_Assignments__Move_Rooms_for_a_day__Us4r_PyeTASQEy7OoL2-sg?as=scrollable`
        // },
    ],
    helps_detail_screen: [
        {
            label: '¿How to add duties to an Assignment?', 
            instruction: `https://scribehow.com/embed/How_to_Add_Duties_to_a_Daily_Assignment__y9ZyE-9QTYmmOWotqYHvag?as=scrollable`
        },
        {
            label: '¿How to move rooms permanently?', 
            instruction: `https://scribehow.com/embed/Daily_Assignments__Move_Rooms_Permanently__AMrW0hNaS2W6cdVOCv8dGw?as=scrollable`
        },
        {
            label: '¿How to move rooms for a day?', 
            instruction: `https://scribehow.com/embed/Daily_Assignments__Move_Rooms_for_a_day__Us4r_PyeTASQEy7OoL2-sg?as=scrollable`
        },
        {
            label: '¿How to copy rooms to another Assignment?', 
            instruction: `https://scribehow.com/embed/How_to_Copy_Rooms_to_Another_Daily_Assignment__LAph0lGXS8StJ6l7Y44zLg?as=scrollable`
        },
        {
            label: '¿How to delete a room on an Assignment?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_a_Room_on_an_Assignment__q6fFsqOVRp-iHd0kwEQNrg?as=scrollable`
        },
        {
            label: '¿How to modify days of the week rooms are to be cleaned?', 
            instruction: `https://scribehow.com/embed/How_To_Modify_Days_of_the_Week_Rooms_are_to_be_Cleaned__OEhjtv9YTxO0atchaP3T6g?as=scrollable`
        },
        {
            label: '¿How to change the order of rooms on an Assignment?', 
            instruction: `https://scribehow.com/embed/Change_the_Order_of_Rooms_on_an_Assignment__hprJpE2uTeaBKXJo_D6jLw?as=scrollable`
        },
    ]


}

export default Resources;